/**
 * cn.ts
 * Utilitaire pour fusionner les classes className
 * Compatible avec Tailwind CSS et clsx
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Fusionne les classes className en gérant les conflits Tailwind
 * @param inputs - Classes à fusionner
 * @returns String de classes fusionnées
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
